import {
    take,
    put,
    call,
    all,
    takeEvery,
} from 'redux-saga/effects';
import { leaveAction as actions, notificationActions } from '../actions';
import { leaveService } from '../services';

/* Add LeaveType Sagas */
function* handleAddLeaveTypeRequest() {
    const action = yield take(actions.addLeaveTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.addLeaveType, dataParams);
        if (res.isError) {
            yield put(actions.addLeaveTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addLeaveTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addLeaveTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Leave Types Sagas */
function* handleGetAllLeaveTypesRequest() {
    const action = yield take(actions.getAllLeaveTypesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getAllLeaveTypes, dataParams);
        if (res.isError) {
            yield put(actions.getAllLeaveTypesError(res));
        } else {
            yield put(actions.getAllLeaveTypesSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllLeaveTypesError());
    }
}

/* Update Leave Type Sagas */
function* handleUpdateLeaveTypeRequest() {
    const action = yield take(actions.updateLeaveTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.updateLeaveType, dataParams);
        if (res.isError) {
            yield put(actions.updateLeaveTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateLeaveTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateLeaveTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Leave Type Sagas */
function* handleDeleteLeaveTypeRequest() {
    const action = yield take(actions.deleteLeaveTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.deleteLeaveType, dataParams);
        if (res.isError) {
            yield put(actions.deleteLeaveTypeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteLeaveTypeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteLeaveTypeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Add Leave Setting Sagas */
function* handleAddLeaveSettingRequest() {
    const action = yield take(actions.addLeaveSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.addLeaveSetting, dataParams);
        if (res.isError) {
            yield put(actions.addLeaveSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addLeaveSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addLeaveSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Leave Setting Sagas */
function* handleGetAllLeaveSettingRequest() {
    const action = yield take(actions.getAllLeaveSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getAllLeaveSetting, dataParams);
        if (res.isError) {
            yield put(actions.getAllLeaveSettingError(res));
        } else {
            yield put(actions.getAllLeaveSettingSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAllLeaveSettingError());
    }
}

/* Get Leave Setting By Leave Id Sagas */
function* handlegetLeaveSettingByLeaveIdRequest() {
    const action = yield take(actions.getLeaveSettingByLeaveIdRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveSettingByLeaveId, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveSettingByLeaveIdError(res));
        } else {
            yield put(actions.getLeaveSettingByLeaveIdSuccess(res));
        }
    } catch (error) {
        yield put(actions.getLeaveSettingByLeaveIdError());
    }
}

/* Update Leave Setting Sagas */
function* handleUpdateLeaveSettingRequest() {
    const action = yield take(actions.updateLeaveSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.updateLeaveSetting, dataParams);
        if (res.isError) {
            yield put(actions.updateLeaveSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateLeaveSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateLeaveSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Delete Leave Setting Sagas */
function* handleDeleteLeaveSettingRequest() {
    const action = yield take(actions.deleteLeaveSettingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.deleteLeaveSetting, dataParams);
        if (res.isError) {
            yield put(actions.deleteLeaveSettingError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteLeaveSettingSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteLeaveSettingError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Leave Constant Data Sagas */
function* handleGetLeaveConstantDataRequest() {
    const action = yield take(actions.getLeaveConstantDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveConstantData, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveConstantDataError(res));
        } else {
            yield put(actions.getLeaveConstantDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getLeaveConstantDataError());
    }
}

/* Get Get Leave Type List Sagas */
function* handleGetLeaveTypeListRequest() {
    const action = yield take(actions.getLeaveTypeListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveTypeList, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveTypeListError(res));
        } else {
            yield put(actions.getLeaveTypeListSuccess(res));
        }
    } catch (error) {
        yield put(actions.getLeaveTypeListError());
    }
}

// Apply Leave Saga
function* handleApplyLeaveRequest() {
    const action = yield take(actions.applyLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.applyLeave, dataParams);
        if (res.isError) {
            yield put(actions.applyLeaveError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.applyLeaveSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.applyLeaveError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get Leave Balance Saga
function* handleGetAllLeaveBalanceRequest() {
    const action = yield take(actions.getLeaveBalanceRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveBalance, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveBalanceError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getLeaveBalanceSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getLeaveBalanceError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get Leave Balance Saga
function* handleGetEmployeeAppliedLeaveRequest() {
    const action = yield take(actions.getEmployeeAppliedLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getEmployeeAppliedLeave, dataParams);
        if (res.isError) {
            yield put(actions.getEmployeeAppliedLeaveError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getEmployeeAppliedLeaveSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getEmployeeAppliedLeaveError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Approve reject leave Saga
function* handleApproveRejectLeaveRequest() {
    const action = yield take(actions.approveRejectLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.approveRejectLeave, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectLeaveError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.approveRejectLeaveSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.approveRejectLeaveError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Cancel leave Saga
function* handleCancelLeaveRequest() {
    const action = yield take(actions.cancelLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.cancelLeave, dataParams);
        if (res.isError) {
            yield put(actions.cancelLeaveError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.cancelLeaveSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.cancelLeaveError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get Leave Approvel Balance Saga
function* handleGetEmployeeApprovelLeaveRequest() {
    const action = yield take(actions.getEmployeeApprovelLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getEmployeeApprovelLeave, dataParams);
        if (res.isError) {
            yield put(actions.getEmployeeApprovelLeaveError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getEmployeeApprovelLeaveSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getEmployeeApprovelLeaveError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get Leave All Employee On leave In date renge
function* handleAllEmployeeLeaveRequest() {
    const action = yield take(actions.getAllEmployeeLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getAllEmployeeLeave, dataParams);
        if (res.isError) {
            yield put(actions.getAllEmployeeLeaveError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getAllEmployeeLeaveSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getAllEmployeeLeaveError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get LeavProgress
function* handleGetLeaveProgressRequest() {
    const action = yield take(actions.getLeaveProgressRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveProgress, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveProgressError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getLeaveProgressSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getLeaveProgressError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

// Get sandwich Leaves Dates
function* handleSandwichLeavesDatesRequest() {
    const action = yield take(actions.sandwichLeavesDatesRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.sandwichLeavesDates, dataParams);
        if (res.isError) {
            yield put(actions.sandwichLeavesDatesError(res));
            // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.sandwichLeavesDatesSuccess(res));
            // yield put(notificationActions.openSnackbar({ text: res?.data?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.sandwichLeavesDatesError());
        // yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Check Leave Encashment Formula */
function* handleCheckLeaveEncashmentFormulaRequest() {
    const action = yield take(actions.checkLeaveEncashmentFormulaRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.checkLeaveEncashmentFormula, dataParams);
        if (res.isError) {
            yield put(actions.checkLeaveEncashmentFormulaError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.checkLeaveEncashmentFormulaSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.checkLeaveEncashmentFormulaError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* Credit Debit Leave */
function* handleCreditDebitLeaveRequest() {
    const action = yield take(actions.creditDebitLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.creditDebitLeave, dataParams);
        if (res.isError) {
            yield put(actions.creditDebitLeaveError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.creditDebitLeaveSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.creditDebitLeaveError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Credit Debit Leave */
function* handleGetCreditDebitLeaveRequest() {
    const action = yield take(actions.getCreditDebitLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getCreditDebitLeave, dataParams);
        if (res.isError) {
            yield put(actions.getCreditDebitLeaveError(res));
        } else {
            yield put(actions.getCreditDebitLeaveSuccess(res));
        }
    } catch (error) {
        yield put(actions.getCreditDebitLeaveError());
    }
}

/* Get Comp Off Data*/
function* handleGetCompOffDataRequest() {
    const action = yield take(actions.getCompOffDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getCompOffData, dataParams);
        if (res.isError) {
            yield put(actions.getCompOffDataError(res));
        } else {
            yield put(actions.getCompOffDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getCompOffDataError());
    }
}

/* Approve Reject Comp Off*/
function* handleApproveRejectCompOffRequest() {
    const action = yield take(actions.approveRejectCompOffRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.approveRejectCompOff, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectCompOffError(res));
        } else {
            yield put(actions.approveRejectCompOffSuccess(res));
        }
    } catch (error) {
        yield put(actions.approveRejectCompOffError());
    }
}

/* Apply Tour*/
function* handleApplyTourRequest() {
    const action = yield take(actions.applyTourRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.applyTour, dataParams);
        if (res.isError) {
            yield put(actions.applyTourError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.applyTourSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.applyTourError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Tour Data*/
function* handleGetTourDataRequest() {
    const action = yield take(actions.getTourDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getTourData, dataParams);
        if (res.isError) {
            yield put(actions.getTourDataError(res));
        } else {
            yield put(actions.getTourDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getTourDataError());
    }
}

/* Get Tour Data*/
function* handleGetTourApprovalRequest() {
    const action = yield take(actions.getTourApprovalRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getTourApproval, dataParams);
        if (res.isError) {
            yield put(actions.getTourApprovalError(res));
        } else {
            yield put(actions.getTourApprovalSuccess(res));
        }
    } catch (error) {
        yield put(actions.getTourApprovalError());
    }
}


/* Approve Reject Tour*/
function* handleApproveRejectTourRequest() {
    const action = yield take(actions.approveRejectTourRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.approveRejectTour, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectTourError(res));
        } else {
            yield put(actions.approveRejectTourSuccess(res));
        }
    } catch (error) {
        yield put(actions.approveRejectTourError());
    }
}
/* Get Leave Today */
function* handleGetLeaveTodayRequest() {
    const action = yield take(actions.getLeaveTodayRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveToday, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveTodayError(res));
        } else {
            yield put(actions.getLeaveTodaySuccess(res));
        }
    } catch (error) {
        yield put(actions.getLeaveTodayError());
    }
}

/* Get Employee Leave */
function* handleGetEmployeeLeaveRequest() {
    const action = yield take(actions.getEmployeeLeaveRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getEmployeeLeave, dataParams);
        if (res.isError) {
            yield put(actions.getEmployeeLeaveError(res));
        } else {
            yield put(actions.getEmployeeLeaveSuccess(res));
        }
    } catch (error) {
        yield put(actions.getEmployeeLeaveError());
    }
}

/* Get Leave Ledger */
function* handleGetLeaveLedgerRequest() {
    const action = yield take(actions.getLeaveLedgerRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveLedger, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveLedgerError(res));
        } else {
            yield put(actions.getLeaveLedgerSuccess(res));
        }
    } catch (error) {
        yield put(actions.getLeaveLedgerError());
    }
}

/* Get Leave Ledger report*/
function* handleGetLeaveLedgerReportRequest() {
    const action = yield take(actions.getLeaveLedgerReportRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(leaveService.getLeaveLedgerReport, dataParams);
        if (res.isError) {
            yield put(actions.getLeaveLedgerReportError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.getLeaveLedgerReportSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.getLeaveLedgerReportError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}



/*  -----------Watchers-------------*/
function* handleAddLeaveTypeWatcher() {
    yield takeEvery(
        actions.addLeaveTypeRequest,
        handleAddLeaveTypeRequest,
    );
}

function* handleGetAllLeaveTypesWatcher() {
    yield takeEvery(
        actions.getAllLeaveTypesRequest,
        handleGetAllLeaveTypesRequest,
    );
}

function* handleUpdateLeaveTypeWatcher() {
    yield takeEvery(
        actions.updateLeaveTypeRequest,
        handleUpdateLeaveTypeRequest,
    );
}

function* handleDeleteLeaveTypeWatcher() {
    yield takeEvery(
        actions.deleteLeaveTypeRequest,
        handleDeleteLeaveTypeRequest,
    );
}

function* handleAddLeaveSettingWatcher() {
    yield takeEvery(
        actions.addLeaveSettingRequest,
        handleAddLeaveSettingRequest,
    );
}

function* handleGetAllLeaveSettingWatcher() {
    yield takeEvery(
        actions.getAllLeaveSettingRequest,
        handleGetAllLeaveSettingRequest,
    );
}

function* handlegetLeaveSettingByLeaveIdWatcher() {
    yield takeEvery(
        actions.getLeaveSettingByLeaveIdRequest,
        handlegetLeaveSettingByLeaveIdRequest,
    );
}

function* handleUpdateLeaveSettingWatcher() {
    yield takeEvery(
        actions.updateLeaveSettingRequest,
        handleUpdateLeaveSettingRequest,
    );
}

function* handleDeleteLeaveSettingWatcher() {
    yield takeEvery(
        actions.deleteLeaveSettingRequest,
        handleDeleteLeaveSettingRequest,
    );
}

function* handleGetLeaveConstantDataWatcher() {
    yield takeEvery(
        actions.getLeaveConstantDataRequest,
        handleGetLeaveConstantDataRequest,
    );
}

function* handleGetLeaveTypeListResWatcher() {
    yield takeEvery(
        actions.getLeaveTypeListRequest,
        handleGetLeaveTypeListRequest,
    );
}

function* handleApplyLeaveWatcher() {
    yield takeEvery(
        actions.applyLeaveRequest,
        handleApplyLeaveRequest,
    );
}

function* handleGetLeaveBalanceWatcher() {
    yield takeEvery(
        actions.getLeaveBalanceRequest,
        handleGetAllLeaveBalanceRequest,
    );
}

function* handleGetEmployeeAppliedLeaveWatcher() {
    yield takeEvery(
        actions.getEmployeeAppliedLeaveRequest,
        handleGetEmployeeAppliedLeaveRequest,
    );
}

function* handleApproveRejectLeaveWatcher() {
    yield takeEvery(
        actions.approveRejectLeaveRequest,
        handleApproveRejectLeaveRequest,
    );
}

function* handleCancelLeaveWatcher() {
    yield takeEvery(
        actions.cancelLeaveRequest,
        handleCancelLeaveRequest,
    );
}

function* handleGetEmployeeApprovelLeaveWatcher() {
    yield takeEvery(
        actions.getEmployeeApprovelLeaveRequest,
        handleGetEmployeeApprovelLeaveRequest,
    );
}

function* handleGetAllEmployeeLeaveWatcher() {
    yield takeEvery(
        actions.getEmployeeApprovelLeaveRequest,
        handleAllEmployeeLeaveRequest,
    );
}

function* handleGetLeaveProgressWatcher() {
    yield takeEvery(
        actions.getLeaveProgressRequest,
        handleGetLeaveProgressRequest,
    );
}

function* handleSandwichLeavesDatesWatcher() {
    yield takeEvery(
        actions.sandwichLeavesDatesRequest,
        handleSandwichLeavesDatesRequest,
    );
}

function* handleCheckLeaveEncashmentFormulaWatcher() {
    yield takeEvery(
        actions.checkLeaveEncashmentFormulaRequest,
        handleCheckLeaveEncashmentFormulaRequest,
    );
}

function* handleCreditDebitLeaveWatcher() {
    yield takeEvery(
        actions.creditDebitLeaveRequest,
        handleCreditDebitLeaveRequest,
    );
}

function* handleGetCreditDebitLeaveWatcher() {
    yield takeEvery(
        actions.getCreditDebitLeaveRequest,
        handleGetCreditDebitLeaveRequest,
    );
}

function* handleGetCompOffDataWatcher() {
    yield takeEvery(
        actions.getCompOffDataRequest,
        handleGetCompOffDataRequest,
    );
}

function* handleApproveRejectCompOffWatcher() {
    yield takeEvery(
        actions.approveRejectCompOffRequest,
        handleApproveRejectCompOffRequest,
    );
}


function* handleApplyTourWatcher() {
    yield takeEvery(
        actions.applyTourRequest,
        handleApplyTourRequest,
    );
}


function* handleGetTourDataWatcher() {
    yield takeEvery(
        actions.getTourDataRequest,
        handleGetTourDataRequest,
    );
}


function* handleGetToursApprovalWatcher() {
    yield takeEvery(
        actions.getTourApprovalRequest,
        handleGetTourApprovalRequest,
    );
}
function* handleApproveRejectTourWatcher() {
    yield takeEvery(
        actions.approveRejectTourRequest,
        handleApproveRejectTourRequest,
    );
}

function* handleGetLeaveTodayWatcher() {
    yield takeEvery(
        actions.getLeaveTodayRequest,
        handleGetLeaveTodayRequest,
    );
}

function* handleGetEmployeeLeaveWatcher() {
    yield takeEvery(
        actions.getEmployeeLeaveRequest,
        handleGetEmployeeLeaveRequest,
    );
}

function* handleGetLeaveLedgerWatcher() {
    yield takeEvery(
        actions.getLeaveLedgerRequest,
        handleGetLeaveLedgerRequest,
    );
}

function* handleGetLeaveLedgerReportWatcher() {
    yield takeEvery(
        actions.getLeaveLedgerReportRequest,
        handleGetLeaveLedgerReportRequest,
    );
}

function* rootLeaveSaga() {
    yield all([
        handleAddLeaveTypeRequest(),
        handleAddLeaveTypeWatcher(),

        handleGetAllLeaveTypesRequest(),
        handleGetAllLeaveTypesWatcher(),

        handleUpdateLeaveTypeRequest(),
        handleUpdateLeaveTypeWatcher(),

        handleDeleteLeaveTypeRequest(),
        handleDeleteLeaveTypeWatcher(),

        handleAddLeaveSettingRequest(),
        handleAddLeaveSettingWatcher(),

        handleGetAllLeaveSettingRequest(),
        handleGetAllLeaveSettingWatcher(),

        handlegetLeaveSettingByLeaveIdRequest(),
        handlegetLeaveSettingByLeaveIdWatcher(),

        handleUpdateLeaveSettingRequest(),
        handleUpdateLeaveSettingWatcher(),

        handleDeleteLeaveSettingRequest(),
        handleDeleteLeaveSettingWatcher(),

        handleGetLeaveConstantDataRequest(),
        handleGetLeaveConstantDataWatcher(),

        handleGetLeaveTypeListRequest(),
        handleGetLeaveTypeListResWatcher(),

        handleApplyLeaveRequest(),
        handleApplyLeaveWatcher(),

        handleGetAllLeaveBalanceRequest(),
        handleGetLeaveBalanceWatcher(),

        handleGetEmployeeAppliedLeaveRequest(),
        handleGetEmployeeAppliedLeaveWatcher(),

        handleApproveRejectLeaveRequest(),
        handleApproveRejectLeaveWatcher(),

        handleCancelLeaveRequest(),
        handleCancelLeaveWatcher(),

        handleGetEmployeeApprovelLeaveRequest(),
        handleGetEmployeeApprovelLeaveWatcher(),

        handleAllEmployeeLeaveRequest(),
        handleGetAllEmployeeLeaveWatcher(),

        handleGetLeaveProgressRequest(),
        handleGetLeaveProgressWatcher(),

        handleSandwichLeavesDatesRequest(),
        handleSandwichLeavesDatesWatcher(),

        handleCheckLeaveEncashmentFormulaRequest(),
        handleCheckLeaveEncashmentFormulaWatcher(),

        handleCreditDebitLeaveRequest(),
        handleCreditDebitLeaveWatcher(),

        handleGetCreditDebitLeaveRequest(),
        handleGetCreditDebitLeaveWatcher(),

        handleGetCompOffDataRequest(),
        handleGetCompOffDataWatcher(),

        handleApproveRejectCompOffRequest(),
        handleApproveRejectCompOffWatcher(),

        handleApplyTourRequest(),
        handleApplyTourWatcher(),

        handleGetTourDataRequest(),
        handleGetTourDataWatcher(),


        handleGetTourApprovalRequest(),
        handleGetToursApprovalWatcher(),

        handleApproveRejectTourRequest(),
        handleApproveRejectTourWatcher(),

        handleGetLeaveTodayRequest(),
        handleGetLeaveTodayWatcher(),

        handleGetEmployeeLeaveRequest(),
        handleGetEmployeeLeaveWatcher(),

        handleGetLeaveLedgerRequest(),
        handleGetLeaveLedgerWatcher(),

        handleGetLeaveLedgerReportRequest(),
        handleGetLeaveLedgerReportWatcher()

    ]);
}

export default rootLeaveSaga;
